// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Pr5MN","button":"styles_button__FTOCz","image":"styles_image__wWkUC"};